export const lowerAndTrim = (ele) => {
  return typeof ele === 'string' ? ele?.toLowerCase()?.trim() : null;
};
